import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const BILLING_FEATURE_FLAG = 'billing';

export const billingPlugin = createPlugin({
  id: 'billing',
  routes: {
    root: rootRouteRef,
  },
  featureFlags: [
    {
      name: BILLING_FEATURE_FLAG,
      description: 'Show the Billing page and its sidebar entry.',
    },
  ],
});

export const BillingPage = billingPlugin.provide(
  createRoutableExtension({
    name: 'BillingPage',
    component: () =>
      import('./components/BillingPage').then(m => m.BillingPage),
    mountPoint: rootRouteRef,
  }),
);
